import { render, staticRenderFns } from "./Establishments.vue?vue&type=template&id=16e42d2d&scoped=true"
import script from "./Establishments.vue?vue&type=script&lang=js"
export * from "./Establishments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e42d2d",
  null
  
)

export default component.exports